import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { forkJoin, map, Observable, startWith, Subject, takeUntil, tap } from 'rxjs';
import { IFactory } from 'src/core/interfaces/factory';
import { IProduct } from 'src/core/interfaces/product';
import { User } from 'src/core/interfaces/user';
import Swal from 'sweetalert2';
import { ProductsListComponent } from '../../shared-components/products-list/products-list.component';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { ICustomerAddress } from 'src/core/interfaces/customerAddress';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductsService } from 'src/app/shared/services/products.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { CustomersListComponent } from '../../shared-components/customers-list/customers-list.component';
import { ICustomer } from 'src/core/interfaces/customer';
import { PurchaseOrderService } from 'src/app/shared/services/purchase-order.service';
import { IPurchaseOrderLine } from 'src/core/interfaces/IPurchaseOrderLine';
import { PurchaseOrderStatus } from 'src/assets/static-data/enums/purchase-order-status.enum';
import { Permissions } from 'src/assets/static-data/permissions';
import { TransactionsInternalServicesService } from 'src/app/shared/services/transactions-internal-services.service';
import { PurchaseOrderPdfComponent } from 'src/app/shared/modules/print-templates/purchase-order-pdf/purchase-order-pdf.component';

@Component({
  selector: 'app-create-update-purchase-order',
  templateUrl: './create-update-purchase-order.component.html',
  styleUrl: './create-update-purchase-order.component.scss',
  providers: [DatePipe,CurrencyPipe,DecimalPipe] // Provide DatePipe

})
export class CreateUpdatePurchaseOrderComponent {
  apiUrl = environment.apiURL;
  columns: TableColumn<IPurchaseOrderLine>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_CODE'),
      property: 'itemCode',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('CUSTOMER_ADDRESS'),
      property: 'customerAddress',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_NAME'),
      property: 'itemName',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('QUANTITY'),
      property: 'quantity',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT'),
      property: 'uom',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT_PRICE'),
      property: 'unitPrice',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT') + '%',
      property: 'vatPercentage',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTAL_BEFORE_VAT'),
      property: 'totalBeforeVAT',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT_AMOUNT'),
      property: 'vatAmount',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTALS'),
      property: 'total',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'salesQuotationNumber',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];
  attachmentsColumns: TableColumn<any>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHMENT'),
      property: 'filename',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'download',
      type: 'button',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHED_BY'),
      property: 'attachedBy',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('DATE_AND_TIME'),
      property: 'dateAndTime',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];
  currentPageAttachments = 0;
  isOrderDetails: boolean = true;
  isAttachments: boolean = false;
  allCustomers: any;
  FactoryProducts: any;
  currentUser: User;

  //dateOfToday: Date = new Date();
  factoriesList: IFactory[] = [];
  stateCtrl = new UntypedFormControl();
  stateCtrl2 = new UntypedFormControl();
  purchaseOrderForm: FormGroup;
  filteredFactories$: Observable<IFactory[]>; // Filtered list of factories
  salesMenList$: Observable<User[]>;
  salesMenList: User[] = [];
  mode: 'create' | 'update' | 'copy' | 'view' = 'create';
  downloadLink: any;
  PurchaseOrderStatus = PurchaseOrderStatus; // Expose the enum to the template
  submitted: boolean = false;
  isRtl: boolean = false;
  isLoading: boolean = true;
  isCustomerSelected: boolean = false;
  customerAddresses: ICustomerAddress[] = [];
  canAddLoadingOrder:boolean=true;
  permissions = new Permissions();

  private destroy$ = new Subject<void>();
  @ViewChild('hiddenReport', { static: false }) hiddenReport: PurchaseOrderPdfComponent | undefined;

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private customerService: CustomerService,
    private location: Location,
    private factoryService: FactoryService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private purchaseOrderService: PurchaseOrderService,
    private productsService: ProductsService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private purchaseOrderInternalService: TransactionsInternalServicesService,
    private loadingService: PageLoadingService,
    private cdRef: ChangeDetectorRef, // Inject ChangeDetectorRef
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
  ) {
    this.purchaseOrderForm = this.fb.group({
      id: [0],
      transactionNumber: [{ value: null, disabled: true }, Validators.required],
      customerCode: [{ value: null, disabled: false }, Validators.required],
      customerName: [{ value: null, disabled: true }, Validators.required],
      customerId: [null, Validators.required],
      factoryId: [null, Validators.required],
      transactionDate: [
        {
          value: new Date(),
          disabled: false
        },
        Validators.required
      ],
      status: [{ value: null, disabled: true }, Validators.required],
      salesManId: [{ value: null, disabled: true }, Validators.required],
      vatPercentage: [{ value: 0, disabled: true }, Validators.required],
      vatAmount: [{ value: 0, disabled: true }, Validators.required],
      totalBeforeVAT: [{ value: 0, disabled: true }, Validators.required],
      total: [{ value: 0, disabled: true }, Validators.required],
      custCurrentBalance: [
        { value: null, disabled: true },
        Validators.required
      ],
      custCreditLimit: [{ value: null, disabled: true }, Validators.required],
      // parentSalesOrderId:[null],
      purchaseOrderLines: this.fb.array([]),
      documentAttachments: this.fb.array([]),
      notes: [null]
    });
  }

  //isLoading$=this.loadingService.isLoading$;

  ngOnInit() {
    console.log(this.mode);
    console.log(PurchaseOrderStatus[this.purchaseOrderForm.get('status').value]);
    //this.loadingService.setLoading(false);
    this.currentUser = this.authService.currentUserValue;

    this.userService.checkPermission(this.currentUser?.id, this.permissions.CREATE_LOADING_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canAddLoadingOrder = response.data;
    })
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur' ? true : false;

    const id = this.route.snapshot.paramMap.get('id');
    this.getAllDropDownLists()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        // this.getAllDropDownLists().subscribe((res) => {
        if (id == null) {
          this.mode = 'create';
          this.generateEmptyRows(1);
          //NOteee commented to test
          this.purchaseOrderLines.controls.forEach((row) => {
            row.disable();
          });
          this.documentAttachments.controls.forEach((row) => {
            row.disable();
          });
        } else {
          const currentRoute = this.route.snapshot.url
            .map((segment) => segment.path)
            .join('/');
          //// // debugger;

          if (currentRoute.includes('edit')) {
            this.mode = 'update';
          } else if (currentRoute.includes('view')) {
            this.mode = 'view';
          } else {
            this.mode = 'copy';
            this.purchaseOrderForm.get('customerCode').disable();
          }
          //// debugger
          this.purchaseOrderService
            // .getSalesOrderById(+id)
            .getPurchaseOrderById(+id)
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
              //// // debugger;
              if (this.mode == 'update') {
                res.data.status != 0
                  ? this.purchaseOrderForm.get('customerCode').disable()
                  : null;
              }
              this.purchaseOrderForm.patchValue({
                id: res.data.id,
                transactionNumber: res.data.transactionNumber,
                customerCode: res.data.customerCode,
                customerName: res.data.customerName,
                customerId: res.data.customerId,
                factoryId: res.data.factoryId,
                transactionDate: res.data.transactionDate || '',
                status: this.purchaseOrderInternalService.getStatusKeyFromValue(
                  res.data.status,
                  3
                ),

                salesManId: res.data.salesManId,
                vatPercentage: res.data.vatPercentage,
                vatAmount: parseFloat(res.data.vatAmount.toFixed(4)),
                totalBeforeVAT: parseFloat(res.data.totalBeforeVAT.toFixed(4)),
                total: parseFloat(res.data.total.toFixed(4)),
                custCurrentBalance: res.data.customerCurrentBalance,
                custCreditLimit: res.data.customerCreditLimit,
                notes:res.data.notes,
           
                // parentSalesOrderId: res.data.parentSalesOrderId,

                //purchaseOrderLines: res.data.purchaseOrderLines,
                //documentAttachments:res.data.documentAttachments
              });

              //// // debugger;
              res.data.documentAttachments.forEach(
                (attachment: any, index: number) => {
                  const attachmentGroup = this.fb.group({
                    id: [attachment.id],
                    filename: [attachment.filename, Validators.required],
                    attachedBy: [
                      attachment.updatedBy
                        ? attachment.updatedBy
                        : attachment.createdBy,
                      Validators.required
                    ],
                    dateAndTime: [
                      this.datePipe.transform(
                        attachment.updatedAt
                          ? attachment.updatedAt
                          : attachment.createdAt,
                        'yyyy-MM-dd HH:mm:ss'
                      ) || '',
                      Validators.required
                    ],
                    path: [attachment.path, Validators.required],
                    fileContent: [attachment.path, Validators.required]
                  });

                  // Push each attachment group to the FormArray
                  this.documentAttachments.push(attachmentGroup);

                  // this.documentAttachments.controls = [
                  //   ...this.documentAttachments.controls
                  // ];
                  if (this.mode == 'view') {
                    //// // debugger;
                    this.documentAttachments.at(index).disable();
                  }
                  if (this.mode == 'update') {
                    //// // debugger;
                    this.documentAttachments
                      .at(index)
                      .get('attachedBy')
                      .disable();
                    this.documentAttachments
                      .at(index)
                      .get('dateAndTime')
                      .disable();
                  }

                  this.documentAttachments.controls = [
                    ...this.documentAttachments.controls
                  ];
                }
              );

              res.data.purchaseOrderLines.forEach((lines: any, index: number) => {
                const orderLines = this.fb.group({
                  id: [lines.id],
                  unitPriceWithTax: [0],
                  itemCode: [lines.itemCode, Validators.required],
                  itemName: [lines.itemName, Validators.required],
                  itemId: [lines.itemId, Validators.required],
                  quantity: [lines.quantity, Validators.required],
                  uom: [lines.uom, Validators.required],
                  unitPrice: [lines.unitPrice, Validators.required],
                  total: [
                    parseFloat(lines.total.toFixed(4)),
                    Validators.required
                  ],
                  vatPercentage: [lines.vatPercentage, Validators.required],
                  vatAmount: [
                    parseFloat(lines.vatAmount.toFixed(4)),
                    Validators.required
                  ],
                  totalBeforeVAT: [
                    parseFloat(lines.totalBeforeVat.toFixed(4)),
                    Validators.required
                  ],
                  customerAddressId: [
                    lines.customerAddressId,
                    Validators.required
                  ],
                  customerAddress: [lines.customerAddress],
                  salesQuotationNumber: [lines.parentSalesQuotationRefNumber],
                  salesQuotationId: [lines.parentSalesQuotationId],
                  salesQuotationLineId:[lines.ParentSalesQuotationLineId]
                });

                // Push each attachment group to the FormArray
                this.purchaseOrderLines.push(orderLines);

                // this.purchaseOrderLines.controls = [
                //   ...this.purchaseOrderLines.controls
                // ];

                this.lineInputChanges(index, 'quantity');

                if (this.mode == 'view') {
                  this.purchaseOrderLines.at(index).disable();
                  // this.purchaseOrderLines.at(index).get('customerAddress')?.disable(); // Disable the customerAddress field
                  // this.purchaseOrderLines.at(index).get('customerAddressId')?.disable(); // Disable the customerAddress field
                  // this.purchaseOrderLines.at(index).updateValueAndValidity(); // Ensure the form state is updated
                  // console.log('Customer address field disabled for review mode'); // Debug log
                }
                if (this.mode == 'update') {
                  this.purchaseOrderLines.at(index).get('itemName').disable();
                  this.purchaseOrderLines.at(index).get('uom').disable();
                  this.purchaseOrderLines.at(index).get('vatPercentage').disable();
                  this.purchaseOrderLines.at(index).get('vatAmount').disable();
                  this.purchaseOrderLines
                    .at(index)
                    .get('totalBeforeVAT')
                    .disable();
                  this.purchaseOrderLines.at(index).get('total').disable();
                  // this.purchaseOrderLines.at(index).get('customerAddressId').disable();
                  // this.purchaseOrderLines.at(index).get('customerAddress').disable();
                }

                this.purchaseOrderLines.controls = [
                  ...this.purchaseOrderLines.controls
                ];

                // if(lines.itemId && lines.customerAddressId && res.data.customerId){
                //   this.getSelectedProductPrice(res.data.customerId,lines.itemId,lines.customerAddressId, index);
                // }

                this.changepurchaseOrderLinesNumbersCurrency(index, 'unitPrice');
                this.changepurchaseOrderLinesNumbersCurrency(index, 'total');
                this.changepurchaseOrderLinesNumbersCurrency(index, 'vatAmount');
                this.changepurchaseOrderLinesNumbersCurrency(
                  index,
                  'totalBeforeVAT'
                );

                this.changepurchaseOrderLinesNumbers(index, 'quantity');
              });


              //this.stateCtrl.setValue(res.data.factoryId?`${res.data.factoryCode} - ${res.data.factoryName}`:'');
              this.displayFactory(
                this.factoriesList.find(
                  (factory) => factory.id === res.data.factoryId
                )
              );
              this.stateCtrl.setValue(
                this.factoriesList.find(
                  (factory) => factory.id === res.data.factoryId
                )
              );

              //// // debugger;
              this.displaySalesMan(
                this.salesMenList.find(
                  (salesMan) => salesMan.id == res.data.salesManId
                )
              );
              this.stateCtrl2.setValue(
                this.salesMenList.find(
                  (salesMan) => salesMan.id == res.data.salesManId
                )
              );

              if (this.mode == 'copy') {
                this.purchaseOrderForm.patchValue({
                  //parentSalesOrderId: res.data.id,
                  id: 0
                });
              } else if (this.mode == 'view') {
                this.purchaseOrderForm.disable();
                this.stateCtrl.disable();
                this.stateCtrl2.disable();
              }

              //this.loadingService.setLoading(false);
              //this.cdRef.detectChanges();
              //----------------------
              this.loadCustomerAddresses(res.data.customerId);
            });
          this.isLoading = false;
        }
      });

    // Filter factories based on user input
    this.filteredFactories$ = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value ? value.name : ''
      ),
      map((name) => {
        if (name) {
          return this._filterList(name, 0);
        } else {
          this.purchaseOrderForm.get('factoryId').reset();
          return this.factoriesList.slice();
        }
      }),
      tap(() => this.purchaseOrderForm.get('factoryId').markAsTouched())
    );

    this.salesMenList$ = this.stateCtrl2.valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value ? value.userName : ''
      ),
      map((name) => {
        if (name) {
          return this._filterList(name, 1);
        } else {
          this.purchaseOrderForm.get('salesManId').reset();
          return this.salesMenList.slice();
        }
      }),
      tap(() => this.purchaseOrderForm.get('salesManId').markAsTouched()) // Mark as touched here
    );

    this.customerService
      .getAllCustomers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.allCustomers = data?.data;
      });

    // this.productsService
    //   .getProducts()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((data) => {
    //     this.FactoryProducts = data?.data;
    //   });

       // Listen to changes in the FormArray
    // this.purchaseOrderLines.valueChanges.subscribe(_=>{
    //   // debugger
    // this.purchaseOrderLines.controls.forEach((control, index) => {
    //   // debugger
    //   control.get('itemId').valueChanges.pipe(
    //     debounceTime(300),
    //     filter((value) => !!value)
    //   ).subscribe((productId) => {
    //     if(control.get('customerAddressId').value && this.purchaseOrderForm.get('customerId').value){
    //       this.getSelectedProductPrice(this.purchaseOrderForm.get('customerId').value,productId, control.get('customerAddressId').value, index);
    //     }
    //   });

    //   control.get('customerAddressId').valueChanges.pipe(
    //     debounceTime(300),
    //     filter((value) => !!value)
    //   ).subscribe((customerAddressId) => {
    //     if(control.get('itemId').value && this.purchaseOrderForm.get('customerId').value){
    //       this.getSelectedProductPrice(this.purchaseOrderForm.get('customerId').value,control.get('itemId').value, customerAddressId, index);
    //     }      
    //   });
    // });})
  }
  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }

  get purchaseOrderLines(): FormArray {
    return this.purchaseOrderForm.get('purchaseOrderLines') as FormArray;
  }
  get documentAttachments(): FormArray {
    return this.purchaseOrderForm.get('documentAttachments') as FormArray;
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  get visibleColumnsAttachments() {
    return this.attachmentsColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  trackByPropertyAttachments<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }
  //0:Order details, 1:attachments
  createEmptyRow(mode: number): FormGroup {
    let row = null;
    if (mode == 0) {
      row = this.fb.group({
        id: [0],
        itemCode: [{ value: '', disabled: true }, Validators.required],
        itemId: [null, Validators.required],
        itemName: [{ value: '', disabled: true }, Validators.required],
        quantity: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        uom: [{ value: '', disabled: true }, Validators.required],
        unitPrice: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        // Add new fields for sales quotation reference
        salesQuotationNumber: [''],
        salesQuotationId: [null],
        parentSalesQuotationId: [null],
        salesQuotationLineId: [null],
        unitPriceWithTax: [0],
        total: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        vatPercentage: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        totalBeforeVAT: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        vatAmount: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        //TODO         customerAddressId: [{ value: null, disabled: !this.isCustomerSelected }, Validators.required],

        customerAddressId: [
          { value: -1, disabled: true }, // Set default to Factory Delivery
          Validators.required
      ],
      customerAddress: [{ value: 'Factory Delivery', disabled: true }, Validators.required] // Set default name
  });
      //NOteee commented to test

      // // Disable all controls initially
      // Object.keys(row.controls).forEach(key => {
      //   row.get(key)?.disable();
      // });
    } else {
      row = this.fb.group({
        id: [0],
        filename: [{ value: '', disabled: true }, Validators.required],
        attachedBy: [{ value: '', disabled: true }, Validators.required],
        dateAndTime: [{ value: null, disabled: true }, [Validators.required]],
        path: [null, Validators.required],
        fileContent: [{ value: null, disabled: true }, Validators.required]
      });
    }
    row.updateValueAndValidity(); // Force validation to trigger immediately
    return row;
  }

  //initial generation
  generateEmptyRows(count: number) {
    //// // debugger;

    const rows = this.purchaseOrderForm.get('purchaseOrderLines') as FormArray;
    for (let i = 0; i < count; i++) {
      rows?.push(this.createEmptyRow(0));
      //this.checkAndEnableNextRow(i)
    }

    const rowsAttach = this.purchaseOrderForm.get(
      'documentAttachments'
    ) as FormArray;
    for (let i = 0; i < count; i++) {
      rowsAttach.push(this.createEmptyRow(1));
      //this.checkAndEnableNextRow(i);
    }

    //enable first row only
    this.enableRow(0);

    this.purchaseOrderLines.controls = [...this.purchaseOrderLines.controls];
    this.documentAttachments.controls = [...this.documentAttachments.controls];
    this.isLoading = false;
  }
  addItem(): void {
    //// // debugger;
    this.purchaseOrderLines.controls.forEach((control, index) => {
      console.log(
        `Row ${index} - customerAddress enabled:`,
        control.get('customerAddress')?.enabled
      );
    });
    if (!this.isCustomerSelected && this.mode !== 'update') {
      console.log('no customr Selected');
      return;
    }
    if (
      this.mode == 'update' &&
      PurchaseOrderStatus[this.purchaseOrderForm.get('status').value] != '0'
    ) {
      console.log("not in draft so won't add items");
      return;
    }
    if (this.isOrderDetails) {
      const newRow = this.createEmptyRow(0);
      newRow.disable();
      console.log('newRow');
      console.log(newRow);
      //NOteee commented to test

      // If customer is selected and addresses exist, set default address
      /* if ((this.isCustomerSelected ||this.purchaseOrderForm.get('status').value)&& this.customerAddresses.length > 0) {
      const defaultAddress = this.customerAddresses[0];
      newRow.patchValue({
        customerAddressId: defaultAddress.id,
        customerAddress: `${defaultAddress.name} - ${defaultAddress.city}, ${defaultAddress.street}`
      });
      newRow.get('customerAddressId')?.enable();
    }
    else{
      newRow.get('customerAddressId')?.disable();

    }*/
      console.log(this.purchaseOrderLines);
      this.purchaseOrderLines.push(newRow); // Add the new FormGroup to the FormArray
      this.purchaseOrderLines.updateValueAndValidity();
      this.purchaseOrderLines.controls = [...this.purchaseOrderLines.controls];
      // Enable the new row if the previous row is valid
      if (this.purchaseOrderLines.length > 1) {
        this.checkAndEnableNextRow(this.purchaseOrderLines.length - 2);
      }
      //  this.purchaseOrderLines.at(this.purchaseOrderLines.length - 1).get('customerAddressId')?.enable(); // {{ edit_1 }}
    } else {
      //// // debugger;
      const newRow = this.createEmptyRow(1);

      this.documentAttachments.push(newRow); // Add the new FormGroup to the FormArray
      this.documentAttachments.updateValueAndValidity();
      this.documentAttachments.controls = [
        ...this.documentAttachments.controls
      ];
      // Enable the new row if the previous row is valid
      if (this.documentAttachments.length > 1) {
        this.checkAndEnableNextRow(this.documentAttachments.length - 2);
      } else {
        this.enableRow(0);
      }
    }
  }
  //NOteee commented to test

  // Add new method to disable rows
  // disableRow(index: number): void {
  //   if (this.isOrderDetails) {
  //     const control = this.purchaseOrderLines.at(index);
  //     if (control) {
  //       control.get('itemCode').disable();
  //       control.get('quantity').disable();
  //       control.get('unitPrice').disable();
  //       control.get('customerAddressId').disable();
  //     }
  //   } else {
  //     const control = this.documentAttachments.at(index);
  //     if (control) {
  //       control.get('filename').disable();
  //     }
  //   }
  // }
  loadCustomerAddresses(customerId: number) {
    this.customerService
      .getCustomerById(customerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          // Add default address for Factory Delivery
          const factoryDeliveryAddress = {
            id: -1, // ID to be sent to backend
            name: 'Factory Delivery', // Default name
            // Add any other necessary fields here
          };
  
          // Prepend the default address to the list of customer addresses
          this.customerAddresses = [factoryDeliveryAddress, ...response.data.customerAddresses];
  
          // Check if the form already has a selected address
          const currentAddressId = this.purchaseOrderLines.at(0).get('customerAddressId')?.value;
  
          // If no address is selected, set the default address
          if (!currentAddressId) {
            this.purchaseOrderLines.at(0).patchValue({
              customerAddressId: factoryDeliveryAddress.id, // Set the ID of the default address
              customerAddress: factoryDeliveryAddress.name // Set the name of the default address
            });
          }
        },
        error: (error) => {
          console.error('Error loading customer addresses:', error);
        }
      });
  }

  changepurchaseOrderLinesNumbersCurrency(i: number, formControl: string) {
    const value = this.purchaseOrderLines.at(i)?.get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted =
        this.currencyPipe
          .transform(value, 'SAR', 'symbol', '1.0-4')
          .replace('SAR', '') + ' SAR';
      this.purchaseOrderLines
        .at(i)
        ?.get(formControl)
        .setValue(formatted, { emitEvent: false });
    }
  }

  changepurchaseOrderLinesNumbers(i: number, formControl: string) {
    const value = this.purchaseOrderLines.at(i)?.get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted = this.decimalPipe.transform(value, '1.0-4') || '';
      this.purchaseOrderLines
        .at(i)
        ?.get(formControl)
        .setValue(formatted, { emitEvent: false });
    }
  }
  lineInputChanges(index: number, formControl?: string): void {
    //this.checkAndEnableNextRow(index);

    if (['quantity', 'vatPercentage', 'unitPrice'].includes(formControl)) {
      this.purchaseOrderLines.at(index).patchValue({
        totalBeforeVAT:
          this.getFormattedNumber(index, 'unitPrice') *
          this.getFormattedNumber(index, 'quantity')
      });
      this.purchaseOrderLines.at(index).patchValue({
        vatAmount:
          this.getFormattedNumber(index, 'totalBeforeVAT') *
          (this.getFormattedNumber(index, 'vatPercentage') / 100)
      });
      this.purchaseOrderLines.at(index).patchValue({
        total:
          this.getFormattedNumber(index, 'totalBeforeVAT') +
          this.getFormattedNumber(index, 'vatAmount')
      });
      //////////////////////////////////////////////

      this.purchaseOrderForm
        .get('totalBeforeVAT')
        .patchValue(this.calculateColumnSum('totalBeforeVAT'));
      this.purchaseOrderForm
        .get('vatAmount')
        .patchValue(this.calculateColumnSum('vatAmount'));
      this.purchaseOrderForm
        .get('total')
        .patchValue(this.calculateColumnSum('total'));

      if (index == 0) {
        this.purchaseOrderForm
          .get('vatPercentage')
          .patchValue(
            this.purchaseOrderLines.at(index).get('vatPercentage').value
          );
      }
    }
    if (['filename'].includes(formControl)) {
      this.documentAttachments.at(index).patchValue({
        attachedBy: this.authService.currentUserValue.firstName,
        dateAndTime: this.datePipe.transform(
          this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss') || '',
          'dd/MM/yyyy HH:mm:ss'
        )
      });
    }

    if(['itemCode','customerAddressId','customerId'].includes(formControl)){
      // debugger
      if(this.purchaseOrderLines.at(index)?.get('itemId').value && this.purchaseOrderLines.at(index)?.get('customerAddressId').value && this.purchaseOrderForm.get('customerId').value){
        this.getSelectedProductPrice(this.purchaseOrderForm.get('customerId').value,this.purchaseOrderLines.at(index)?.get('itemId').value,this.purchaseOrderLines.at(index)?.get('customerAddressId').value, index);
        this.enableRow(index);
      }
    }
    this.documentAttachments.controls = [...this.documentAttachments.controls];
    this.purchaseOrderLines.controls = [...this.purchaseOrderLines.controls];
    this.checkAndEnableNextRow(index);
  }

  checkAndEnableNextRow(index: number): void {
    //// // debugger;
    if (this.isOrderDetails) {
      if (
        this.purchaseOrderLines.at(index).valid &&
        this.purchaseOrderLines.at(index).enabled &&
        index < this.purchaseOrderLines.length - 1
      ) {
        this.enableRow(index + 1); // Enable the next row if current row is valid
      }

      if (index == 0 && this.mode !== 'view') {
        this.enableRow(0);
      }
    } else {
      if (
        this.documentAttachments.at(index).valid &&
        this.documentAttachments.at(index).enabled &&
        index < this.documentAttachments.length - 1
      ) {
        this.enableRow(index + 1); // Enable the next row if current row is valid
      }
      if (index == 0 && this.mode !== 'view') {
        this.enableRow(0);
      }
    }
  }

  enableRow(index: number): void {
    // // debugger;
    if (index == 0 && this.mode !== 'view') {
      this.purchaseOrderLines.at(index)?.get('itemCode').enable();
      this.purchaseOrderLines.at(index)?.get('customerAddressId').enable();
      
      if(this.purchaseOrderLines.at(index)?.get('itemCode').value && this.purchaseOrderLines.at(index)?.get('customerAddressId').value){
      this.purchaseOrderLines.at(index)?.get('quantity').enable();
      this.purchaseOrderLines.at(index)?.get('unitPrice').enable();
    }
      this.purchaseOrderLines.at(index)?.get('customerAddress').enable();
      this.documentAttachments.at(index)?.get('filename').enable();
      this.documentAttachments.at(index)?.enable();
    } else if (this.isOrderDetails) {
      const control = this.purchaseOrderLines.at(index);
      if (control) {
        control.get('itemCode').enable();
        control.get('customerAddressId').enable();
        if(control.get('itemCode').value && control.get('customerAddressId').value){

        control.get('unitPrice').enable();
        control.get('quantity').enable();
        }
        control.get('customerAddress').enable();
        // control.get('unitPrice').enable();// Enable the FormGroup at the specified index
      }
    } else {
      const control = this.documentAttachments.at(index);
      if (control) {
        control.get('filename').enable(); // Enable the FormGroup at the specified index
      }
    }
  }
  onDownloadClick(index: number): void {
    //// // debugger;
    const uploadedFile = this.documentAttachments.at(index).get('path').value;

    let url: string;

    if (typeof uploadedFile === 'string') {
      // If uploadedFile is a string (file path), construct the URL to the file
      // Assuming the file is served via HTTP (make sure the file is publicly accessible)
      url = `${this.apiUrl}/${uploadedFile.replace(/\\/g, '/')}`;
      // Trigger the download
      const link = document.createElement('a');
      //link.href = url;
      link.download = uploadedFile.split('/').pop() || 'download'; // Use the last part of the path as the file name
      link.click(); // Simulate the click to trigger download
    } else {
      // If uploadedFile is a Blob object, create a blob URL
      url = URL.createObjectURL(uploadedFile);
    }

    // If the URL is a Blob URL, clean up after the download to free up memory
    if (typeof uploadedFile !== 'string') {
      this.downloadLink = url;
      //URL.revokeObjectURL(url);
    }
  }

  onFileChange(event, index: number): void {
    //// // debugger;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.documentAttachments.at(index).patchValue({
        filename: file.name,
        fileContent: file,
        path: file
      });

      this.lineInputChanges(index, 'filename');

      // this.form.patchValue({
      //   license: file,
      // });
      // this.selectedFile = file ?? null;
      const fileType = file.type;

      // this.resetPreview();

      const reader = new FileReader();

      if (fileType.startsWith('text/')) {
        reader.onload = () => {
          // this.fileContent = reader.result as string;
          // this.isText = true;
        };
        reader.readAsText(file); // Correct method for text files
      } else {
        reader.onload = () => {
          const result = reader.result as string;

          // if (fileType.startsWith('image/')) {
          //   this.isImage = true;
          //   this.imagePreviewUrl = result;
          // } else if (fileType === 'application/pdf') {
          //   this.isPDF = true;
          //   this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result);
          // }
        };
        reader.readAsDataURL(file); // For images and PDFs
      }
    }
  }

  /////////////////////////////////////////////////////////////
  getFormattedNumber(index: number, formControl: string): number {
    const quantity = this.purchaseOrderLines.at(index)?.get(formControl).value;
    // Remove non-numeric characters except for dot and minus sign
    const cleanedValue = quantity
      ? parseFloat(quantity.toString().replace(/[^\d.-]/g, ''))
      : 0;
    return isNaN(cleanedValue) ? 0 : cleanedValue; // Ensure a valid number is returned
  }

  openSearchCustomer() {
    this.dialog
      .open(CustomersListComponent, {
        data: {
          customersList: this.allCustomers,
          customerId: this.purchaseOrderForm.get('customerId').value
        },
        width: '40%',
        maxHeight: '90%'
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedCustomer: ICustomer) => {
        //// // debugger;
        if (selectedCustomer) {
          this.purchaseOrderForm.patchValue({
            customerCode: selectedCustomer.code,
            customerName: selectedCustomer.name,
            customerId: selectedCustomer.id,
            custCurrentBalance: selectedCustomer.currentAccountBalance,
            custCreditLimit: selectedCustomer.creditLimit
          });
          this.loadCustomerAddresses(selectedCustomer.id);

          // Set customer selected flag to true
          this.isCustomerSelected = true;
          this.purchaseOrderLines.clear();
          this.generateEmptyRows(1);
          // Enable first row of order details
          if (this.purchaseOrderLines.length > 0) {
            this.enableRow(0);
          }

          const salesManValue = this.salesMenList.find(
            (salesMan) =>
              salesMan.sapSalesManCode == selectedCustomer.sapSalesPersonCode
          );

          if (selectedCustomer?.sapSalesPersonCode && salesManValue) {
            this.displaySalesMan(salesManValue);
            this.stateCtrl2.setValue(salesManValue);

            this.purchaseOrderForm.patchValue({
              salesManId: salesManValue?.id
            });
          } else {
            this.displaySalesMan(null);
            this.stateCtrl2.setValue(null);

            this.purchaseOrderForm.patchValue({
              salesManId: null
            });
          }

          this.lineInputChanges(0, 'customerId');
        }
      });
  }

  openSearchProducts(index: number) {
    this.dialog
      .open(ProductsListComponent, {
        data: {productsList:this.FactoryProducts,productId:this.purchaseOrderLines.at(index).get('itemId').value},
        width: '40%',
        maxHeight: '90%'
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedProduct: IProduct) => {
        if (selectedProduct) {
          // Get customer ID from the form
          // debugger
          //const customerId = this.purchaseOrderForm.get('customerId').value;
          this.purchaseOrderLines.at(index).patchValue({
            itemCode: selectedProduct.code,
            itemName: selectedProduct.name,
            itemId: selectedProduct.id,
            uom: selectedProduct.sapUoM,
            unitPrice: 0,
            vatPercentage: selectedProduct.salesVatPercentage,
            quantity: 1,
          // Fetch unit price from backend
          });
          this.lineInputChanges(index, 'itemCode');

        }
      });
  }

  getSelectedProductPrice(customerId:number,productId:number,addressId:number,index:number) {
    console.log("addressId")
    console.log(addressId)
    this.purchaseOrderService
    .getUnitPriceForCustomer(
      customerId,
      productId,
      addressId
    )
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (response) => {
        // debugger
        console.log(response);
        this.purchaseOrderLines.at(index).patchValue({
          //itemCode: selectedProduct.code,
          //itemName: selectedProduct.name,
          //itemId: selectedProduct.id,
          //uom: selectedProduct.sapUoM,
          unitPrice: response.data.unitPrice,
          //vatPercentage: selectedProduct.salesVatPercentage,
          //quantity: 1,
          // Store sales quotation reference

          salesQuotationNumber: response.data.salesQuotationNumber,
          salesQuotationId: response.data.salesQuotationId,
          salesQuotationLineId: response.data.salesQuotationLineId,
          parentSalesQuotationId: response.data.salesQuotationId,
          // customerAddressId:response.data.customerAddressId,
          // customerAddressId: this.customerAddresses[index]?.id || null,
          // customerAddress: this.customerAddresses[index]
          //   ? `${this.customerAddresses[0].name} - ${this.customerAddresses[0].city}, ${this.customerAddresses[0].street}`
          //   : ''
        });
        this.lineInputChanges(index, 'unitPrice');
      },
      error: (err) => {
        console.error('Error fetching unit price:', err);
        // Set default values without unit price
        this.purchaseOrderLines.at(index).patchValue({
          //itemCode: selectedProduct.code,
          //itemName: selectedProduct.name,
          //itemId: selectedProduct.id,
          //uom: selectedProduct.sapUoM,
          unitPrice: 0,
          //vatPercentage: selectedProduct.salesVatPercentage,
          quantity: 1,
          parentSalesQuotationId: null // Reset quotation reference if error
        });

        Swal.fire({
          title: this.translateService.instant(
            'NO_PRICE_FOUND_FOR_CUSTOMER'
          ),
          icon: 'warning',
          timer: 2000,
          showConfirmButton: false
        });
      }
    });
  }
  getDynamicWidth(
    index: number,
    formControl: string,
    placeholder?: string
  ): string {
    let inputValue = '';

    if (this.isOrderDetails) {
      inputValue = this.purchaseOrderLines.at(index)?.get(formControl).value;
    } else {
      inputValue = this.documentAttachments.at(index)?.get(formControl).value;
    }
    // Adjust according to your form structure
    // Calculate lengths based on value and placeholder
    const inputLength = inputValue ? inputValue.toString().length : 0;
    const placeholderLength = placeholder ? placeholder.length : 0;

    // Use the longer of the two lengths for width calculation
    const length = Math.max(inputLength, placeholderLength);
    // Base width and multiplier
    const baseWidth = 60; // Minimum width in pixels
    const widthAdjustment = length * 6.8; // Each character adds 6.5px (adjust based on your font size)

    // Returning width as a string with 'px' unit
    return `${baseWidth + widthAdjustment}px`;
  }
  onBack() {
    //// // debugger;
    this.purchaseOrderForm.reset();
    //console.log(this.location.path)
    //this.location.back();

    this.router.navigate(['/transactions/purchase-orders']);
    // this.router.navigate(['/transactions/purchase-orders']);
  }

  onSave(status: number) {
    // // debugger;
    this.submitted = true;
    let savedForm = this.purchaseOrderInternalService.deepCopyFormGroup(
      this.purchaseOrderForm
    ) as FormGroup;
    //console.log("status onSave")
    //console.log(status)
    // Set the status value
    if (status != null) {
      savedForm.get('status').setValue(status);
    } else {
      savedForm
        .get('status')
        .setValue(PurchaseOrderStatus[savedForm.get('status').value]);
    }
    savedForm.removeControl('transactionNumber');

    const validpurchaseOrderLines = (
      savedForm.get('purchaseOrderLines') as FormArray
    ).controls.filter((control) => control.valid);

    // If you need to keep only valid lines in savedForm, you can create a new FormArray
    const validpurchaseOrderLinesArray = new FormArray(validpurchaseOrderLines);
    const validDocumentAttachmentsLines = (
      savedForm.get('documentAttachments') as FormArray
    ).controls.filter((control) => control.valid);

    // If you need to keep only valid lines in savedForm, you can create a new FormArray
    const validDocumentAttachmentsLinesArray = new FormArray(
      validDocumentAttachmentsLines
    );

    // Optionally replace the original salesQuotationLines with the valid ones
    savedForm.setControl('purchaseOrderLines', validpurchaseOrderLinesArray);
    savedForm.setControl(
      'documentAttachments',
      validDocumentAttachmentsLinesArray
    );
    //savedForm.setControl('transactionDate', new FormControl(this.salesOrderInternalService.transformDateFormat(savedForm.get('transactionDate').value)));
    (savedForm.get('purchaseOrderLines') as FormArray).controls.forEach(
      (element, index) => {
        (element as FormGroup).setControl(
          'unitPrice',
          new FormControl(this.getFormattedNumber(index, 'unitPrice'))
        );
        (element as FormGroup).setControl(
          'total',
          new FormControl(this.getFormattedNumber(index, 'total'))
        );
        (element as FormGroup).setControl(
          'vatAmount',
          new FormControl(this.getFormattedNumber(index, 'vatAmount'))
        );
        (element as FormGroup).setControl(
          'totalBeforeVAT',
          new FormControl(this.getFormattedNumber(index, 'totalBeforeVAT'))
        );
        (element as FormGroup).setControl(
          'quantity',
          new FormControl(this.getFormattedNumber(index, 'quantity'))
        );
      }
    );
    if (savedForm.invalid) {
      Swal.fire({
        title: this.translateService.instant('FILL_REQUIRED_FIELDS.TEXT'),
        icon: 'warning',
        timer: 1000, // The alert will disappear after 1000 milliseconds (1 second)
        showConfirmButton: false // Optional: Hide the confirm button
      });
      return;
    } else {
      //console.log(savedForm.value);
      if (this.mode == 'create') {
        this.purchaseOrderService
          .addNewPurchaseOrder(savedForm.value)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res) => {
              Swal.fire({
                title: this.translateService.instant(
                  'PURCHASEORDER_CREATED_SUCCESSFULLY.TEXT'
                ),
                icon: 'success',
                timer: 1000, // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false // Optional: Hide the confirm button
              });

              this.router.navigate(['/transactions/purchase-orders']);
            },
            error: (err) => {
              //console.log(err);
              //console.log()
              Swal.fire({
                title: this.translateService.instant(
                  'PURCHASEORDER_CREATED_FAILED.TEXT'
                ),
                icon: 'error',
                timer: 1000, // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false // Optional: Hide the confirm button
              });
            }
          });
      } else if (this.mode == 'update') {
        //// // debugger;
        this.purchaseOrderService
          .updatePurchaseOrder(savedForm.get('id').value, savedForm.value)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res) => {
              Swal.fire({
                title: this.translateService.instant(
                  'PURCHASEORDER_UPDATED_SUCCESSFULLY.TEXT'
                ),
                icon: 'success',
                timer: 1000, // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false // Optional: Hide the confirm button
              });
              this.router.navigate(['/transactions/purchase-orders']);
            },
            error: (err) => {
              //console.log(err);
              Swal.fire({
                title: this.translateService.instant(
                  'PURCHASEORDER_UPDATED_FAILED.TEXT'
                ),
                icon: 'error',
                timer: 1000, // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false // Optional: Hide the confirm button
              });
            }
          });
      }
    }
  }

  removeLine(i: number): void {
    //// // debugger;
    if (this.isOrderDetails) {
      this.purchaseOrderLines.removeAt(i);
      this.purchaseOrderLines.updateValueAndValidity();
      this.purchaseOrderLines.controls = [...this.purchaseOrderLines.controls];
    } else {
      this.documentAttachments.removeAt(i);
      this.documentAttachments.updateValueAndValidity();
      this.documentAttachments.controls = [
        ...this.documentAttachments.controls
      ];
    }

    this.checkAndEnableNextRow(i + 1);
  }

  getAllDropDownLists() {
    return forkJoin({
      factories: this.factoryService.getFactories(),
      salesMen: this.userService.getSalesAgentUsersList()
    }).pipe(
      tap(({ factories, salesMen }) => {
        // Set the data for each list
        this.factoriesList = factories.data;
        this.salesMenList = salesMen.data;
      })
    );
  }

  // Display function for autocomplete
  displayFactory(factory: IFactory | null): string {
    //// // debugger;
    return factory ? `${factory.code} - ${factory.name}` : '';
  }

  displaySalesMan(salesMan: User | null): string {
    //// // debugger;
    return salesMan ? `${salesMan.userCode} - ${salesMan.userName}` : '';
  }

  ondropDownSelected(event: any, index: number) {
    //// // debugger;
    if (index == 0) {
      const selectedFactory = event.option.value as IFactory;
      this.purchaseOrderForm.patchValue({
        factoryId: selectedFactory.id // Store factory ID in form control
      });
      this.productsService.getFactoryProducts(selectedFactory.id).subscribe((response) => {
        console.log(response.data)
        this.FactoryProducts = response.data;
      });
    } else {
      const selectedSalesMan = event.option.value as User;
      this.purchaseOrderForm.patchValue({
        salesManId: selectedSalesMan.id // Store factory ID in form control
      });
    }
  }

  toggleAction(orderDetails: boolean) {
    // // debugger;
    this.isOrderDetails = orderDetails;
    this.isAttachments = !orderDetails;
  }

  private _filterList(name: string, index: number): any[] {
    // // debugger;
    //0->factories, 1->salesMen
    const filterValue = name.toLowerCase();
    if (index == 0) {
      return this.factoriesList.filter(
        (factory) =>
          factory.name.toLowerCase().includes(filterValue) ||
          factory.code?.toLowerCase().includes(name.toLowerCase())
      );
    } else {
      return this.salesMenList.filter(
        (salesMan) =>
          salesMan.userName.toLowerCase().includes(filterValue) ||
          salesMan.userCode?.toLowerCase().includes(name.toLowerCase())
      );
    }
  }

  calculateColumnSum(column: string): number {
    return this.purchaseOrderLines.controls.reduce((acc, control, index) => {
      //// // debugger;
      const value = this.getFormattedNumber(index, column);
      return acc + (value ? +value : 0); // Convert value to number and add to sum
    }, 0);
  }
  navigateToAddLoadingOrder(row: any) {
    //console.log(row);
    // this.router.navigate(["/transactions/add-loading-order/sales-order/", row.value.id]);
    window.open(
      '/transactions/add-loading-order/sales-order/' + row.value.id,
      '_blank'
    );
  }
  onAddressChange(event: MatSelectChange, index: number) {
    // // debugger;
    const selectedAddressId = event.value;
    const selectedAddress = this.customerAddresses.find(
      (a) => a.id === selectedAddressId
    );

    if (selectedAddress) {
      this.purchaseOrderLines.at(index).patchValue({
        customerAddressId: selectedAddress.id, // Save the address ID
        customerAddress: `${selectedAddress.name}`
      });

      this.lineInputChanges(index,'customerAddressId');
    }
  }

  generatePdf(): void {
    this.purchaseOrderInternalService.generatePdf(this.hiddenReport);
  }
  // ApproveOrder() {
  //   const savedForm = this.purchaseOrderInternalService.deepCopyFormGroup(
  //     this.purchaseOrderForm
  //   ) as FormGroup;
  //   savedForm.get('status').setValue(PurchaseOrderStatus[2]); // Set status to Ready (2)
  //   //console.log(savedForm)

  //   const validpurchaseOrderLines = (
  //     savedForm.get('purchaseOrderLines') as FormArray
  //   ).controls.filter((control) => control.valid);

  //   // If you need to keep only valid lines in savedForm, you can create a new FormArray
  //   const validpurchaseOrderLinesArray = new FormArray(validpurchaseOrderLines);
  //   const validDocumentAttachmentsLines = (
  //     savedForm.get('documentAttachments') as FormArray
  //   ).controls.filter((control) => control.valid);

  //   // If you need to keep only valid lines in savedForm, you can create a new FormArray
  //   const validDocumentAttachmentsLinesArray = new FormArray(
  //     validDocumentAttachmentsLines
  //   );

  //   // Optionally replace the original salesQuotationLines with the valid ones
  //   savedForm.setControl('purchaseOrderLines', validpurchaseOrderLinesArray);
  //   savedForm.setControl(
  //     'documentAttachments',
  //     validDocumentAttachmentsLinesArray
  //   );
  //   //savedForm.setControl('transactionDate', new FormControl(this.salesOrderInternalService.transformDateFormat(savedForm.get('transactionDate').value)));
  //   (savedForm.get('purchaseOrderLines') as FormArray).controls.forEach(
  //     (element, index) => {
  //       (element as FormGroup).setControl(
  //         'unitPrice',
  //         new FormControl(this.getFormattedNumber(index, 'unitPrice'))
  //       );
  //       (element as FormGroup).setControl(
  //         'total',
  //         new FormControl(this.getFormattedNumber(index, 'total'))
  //       );
  //       (element as FormGroup).setControl(
  //         'vatAmount',
  //         new FormControl(this.getFormattedNumber(index, 'vatAmount'))
  //       );
  //       (element as FormGroup).setControl(
  //         'totalBeforeVAT',
  //         new FormControl(this.getFormattedNumber(index, 'totalBeforeVAT'))
  //       );
  //       (element as FormGroup).setControl(
  //         'quantity',
  //         new FormControl(this.getFormattedNumber(index, 'quantity'))
  //       );
  //     }
  //   );
  //   this.purchaseOrderService
  //     .updatePurchaseOrder(savedForm.get('id').value, savedForm.value)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (res) => {
  //         Swal.fire({
  //           title: this.translateService.instant(
  //             'ORDER_APPROVED_SUCCESSFULLY.TEXT'
  //           ),
  //           icon: 'success',
  //           timer: 1000,
  //           showConfirmButton: false
  //         });
  //         this.router.navigate(['/transactions/purchase-orders']); // Navigate to Sales Order page
  //       },
  //       error: (err) => {
  //         //console.error(err);
  //         Swal.fire({
  //           title: this.translateService.instant('ORDER_APPROVAL_FAILED.TEXT'),
  //           icon: 'error',
  //           timer: 1000,
  //           showConfirmButton: false
  //         });
  //       }
  //     });
  // }
}
